import { Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Grid } from "app/interfaces/grid.interface";
import { _GridService } from "app/ng1-services/grid.service";
import { _NotificationService } from "app/services/notification.service";
import { _OrganizationService } from "app/services/organization.service";
import { _TradingAccountService } from "app/services/tradingAccount.service";
import { jqxGridComponent } from "assets/jqwidgets-ts/angular_jqxgrid";

declare var $: any;

@Component({
  selector: "change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.css"],
})
export class NotificationChangePassword implements OnInit {
  @ViewChild("notificationListGrid") notificationListGrid: jqxGridComponent;

  private notificationList: Grid;

  constructor(
    private titleService: Title,
    private gridService: _GridService,
    private notificationService: _NotificationService
  ) {}

  ngOnInit() {
    //Set the page title
    this.titleService.setTitle("WiseRisk | Notifications change password");

    this.loadNotificationList();
  }

  loadNotificationList() {
    this.notificationList = null;
    this.notificationService.getList().then((data) => {
      var source = {
        id: "notificationListId",
        localdata: data,
        datafields: [
          {
            name: "id",
            type: "int",
          },
          {
            name: "type",
            type: "string",
          },
          {
            name: "message",
            type: "string",
          },
        ],

        refresh: () => {
          this.loadNotificationList();
        },
        getGrid: () => {
          return this.notificationListGrid;
        },
      };
      this.notificationList = {
        source: source,
        dataAdapter: new $.jqx.dataAdapter(source),
        columns: [
          {
            text: "Notification name",
            datafield: "type",
            width: "150",
          },
          {
            text: "Message",
            datafield: "message",
            width: "150",
          },
          {
            text: "",
            columntype: "button",
            width: "150",
            cellsrenderer: () => "Decline",
            buttonclick: (row) =>
              this.notificationService
                .delete(this.notificationListGrid.getcellvalue(row, "id"))
                .then(() => this.loadNotificationList()),
          },
          {
            text: "",
            columntype: "button",
            width: "150",
            cellsrenderer: () => "Accept",
            buttonclick: (row) =>
              this.notificationService
                .update(this.notificationListGrid.getcellvalue(row, "id"))
                .then(() => this.loadNotificationList()),
          },
        ],
        renderstatusbar: (statusbar: any) => {},
      };
    });
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/notification/change-password/change-password.component.ts